import React from 'react';
export function PolicyContent() {
  return <section className="py-16 lg:py-20" data-id="element-367">
      <div className="scroll-fade-in-up max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-lg" data-id="element-368">
        <div className="space-y-10 text-muted leading-relaxed" data-id="element-369">
          <div data-id="element-370">
            <h2 className="text-2xl font-bold text-ink mb-4" data-id="element-371">Introduction</h2>
            <p data-id="element-372">
              Magnus Software ("we," "our," or "us") respects your privacy and
              is committed to protecting the personal information you share with
              us. This Privacy Policy explains how we collect, use, disclose,
              and safeguard your information when you visit our website or
              engage with our services.
            </p>
          </div>

          <div data-id="element-373">
            <h2 className="text-2xl font-bold text-ink mb-4" data-id="element-374">
              Information We Collect
            </h2>
            <p className="mb-4" data-id="element-375">
              We may collect the following types of information:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-376">
              <li data-id="element-377">
                <strong className="text-ink" data-id="element-378">Personal Information:</strong>{' '}
                Name, email address, phone number, and company name when you
                contact us or submit a form.
              </li>
              <li data-id="element-379">
                <strong className="text-ink" data-id="element-380">Usage Data:</strong> Information
                about how you access and use our website, including IP address,
                browser type, pages visited, and time spent on pages.
              </li>
              <li data-id="element-381">
                <strong className="text-ink" data-id="element-382">Cookies:</strong> We use cookies
                and similar tracking technologies to enhance your browsing
                experience and analyze website traffic.
              </li>
            </ul>
          </div>

          <div data-id="element-383">
            <h2 className="text-2xl font-bold text-ink mb-4" data-id="element-384">
              How We Use Your Information
            </h2>
            <p className="mb-4" data-id="element-385">We use the information we collect to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-386">
              <li data-id="element-387">Respond to your inquiries and provide customer support</li>
              <li data-id="element-388">Improve and optimize our website and services</li>
              <li data-id="element-389">
                Communicate with you about projects, updates, and relevant
                information
              </li>
              <li data-id="element-390">Comply with legal obligations and protect our rights</li>
            </ul>
          </div>

          <div data-id="element-391">
            <h2 className="text-2xl font-bold text-ink mb-4" data-id="element-392">
              Information Sharing
            </h2>
            <p data-id="element-393">
              We do not sell, trade, or rent your personal information to third
              parties. We may share your information with trusted service
              providers who assist us in operating our website and conducting
              our business, provided they agree to keep your information
              confidential. We may also disclose information when required by
              law or to protect our rights.
            </p>
          </div>

          <div data-id="element-394">
            <h2 className="text-2xl font-bold text-ink mb-4" data-id="element-395">Data Security</h2>
            <p data-id="element-396">
              We implement reasonable administrative, technical, and physical
              security measures to protect your personal information. However,
              no method of transmission over the Internet or electronic storage
              is 100% secure, and we cannot guarantee absolute security.
            </p>
          </div>

          <div data-id="element-397">
            <h2 className="text-2xl font-bold text-ink mb-4" data-id="element-398">
              Third-Party Links
            </h2>
            <p data-id="element-399">
              Our website may contain links to third-party websites. We are not
              responsible for the privacy practices or content of those sites.
              We encourage you to review the privacy policies of any third-party
              sites you visit.
            </p>
          </div>

          <div data-id="element-400">
            <h2 className="text-2xl font-bold text-ink mb-4" data-id="element-401">Your Rights</h2>
            <p data-id="element-402">
              Depending on your jurisdiction, you may have the right to access,
              correct, or delete your personal information. You may also have
              the right to object to or restrict certain processing of your
              data. To exercise these rights, please contact us using the
              information below.
            </p>
          </div>

          <div data-id="element-403">
            <h2 className="text-2xl font-bold text-ink mb-4" data-id="element-404">
              Changes to This Policy
            </h2>
            <p data-id="element-405">
              We may update this Privacy Policy from time to time. Any changes
              will be posted on this page with an updated "Last updated" date.
              We encourage you to review this policy periodically.
            </p>
          </div>

          <div data-id="element-406">
            <h2 className="text-2xl font-bold text-ink mb-4" data-id="element-407">Contact Us</h2>
            <p data-id="element-408">
              If you have any questions about this Privacy Policy or our data
              practices, please contact us at:
            </p>
            <p className="mt-4" data-id="element-409">
              <strong className="text-ink" data-id="element-410">Magnus Software</strong>
              <br data-id="element-411" />
              Phone:{' '}
              <a href="tel:231-266-0606" className="text-accent hover:underline" data-id="element-412">
                231-266-0606
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>;
}